import { render, staticRenderFns } from "./taskView.vue?vue&type=template&id=c8611720&"
import script from "./taskView.vue?vue&type=script&lang=js&"
export * from "./taskView.vue?vue&type=script&lang=js&"
import style0 from "./taskView.vue?vue&type=style&index=0&id=c8611720&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports